<div *ngIf="withdrawalStatus != 'pending'" class="alert alert-warning panel-header" [ngClass]="{'ar': lang=='ar'}"
  (click)="toggleActivationStep()">
  <mat-icon class="fas fa-exclamation-circle" style="margin-top:2px; margin-right: 2px;"></mat-icon>
  <span style="margin-top:-7px;display: inline-block;">{{'Sellers.Dashboard.CompleteVerifySteps' | translate}}</span>

  <!-- <i class="fas " [ngClass]="{'fa-caret-down':!isDown,'fa-caret-up':isDown}"></i> -->
  <i *ngIf="withdrawalStatus == 'pending'" class="fa fa-spinner mx-2"></i>
</div>
<div *ngIf="withdrawalStatus == 'pending'" class="alert alert-success  panel-header" [ngClass]="{'ar': lang=='ar'}"
  (click)="toggleActivationStep()">
  <mat-icon class="fas fa-check-circle" style="margin-top:2px; margin-right: 2px;"></mat-icon>
  <span style="margin-top:-7px;display: inline-block;">{{'Sellers.Dashboard.AwaitVerifySteps' | translate}}</span>

  <!-- <i class="fas " [ngClass]="{'fa-caret-down':!isDown,'fa-caret-up':isDown}"></i> -->
  <i class="fa fa-spinner mx-2"></i>
</div>
<div class="d-flex flex-column" [ngStyle]="{'display': !isDown?'none':'block'}">

  <div class="accordion " id="accordionExample">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
          aria-expanded="true" aria-controls="collapseOne" id="contactInfobtn" [disabled]="!businessContactValid">
          {{ 'Sellers.Products.ContactInfo' | translate }}
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
        data-bs-parent="#accordionExample">
        <div class="accordion-body d-flex flex-column">
          <app-contact-information></app-contact-information>
          <button type="button" (click)="businessInfoStep()" class="btn btn-primary mb-3 align-self-end" >
            {{ 'Buyer.Next' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
          aria-expanded="false" aria-controls="collapseTwo" id="businessInfobtn" [disabled]="!BusinessInfoValid" >
          {{ "Sellers.Products.BusinessInfo" | translate }}
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample">
        <div class="accordion-body  d-flex flex-column">
          <app-business-information></app-business-information>
          <button type="button" (click)="LegalInfoStep()" class="btn btn-primary mb-3 align-self-end ">
            {{ 'Buyer.Next' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingThree">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" id="legalInfobtn" [disabled]="!businessLegalValid">
          {{ "Sellers.Products.LegalInfo" | translate }}
        </button>
      </h2>
      <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
        data-bs-parent="#accordionExample">
        <div class="accordion-body  d-flex flex-column">
          <app-business-legal-information></app-business-legal-information>
          <button type="submit" (click)="onSubmit()" class="btn btn-primary mb-3 align-self-end" [disabled]="!businessLegalValid">
            {{ 'Sellers.Products.Submit' | translate }}
          </button>
        </div>

      </div>

    </div>

  </div>

</div>
